module.exports = {
      id: "logo-small-usage",
      viewBox: "0 0 192 28",
      url: __webpack_public_path__ + "svg-sprite-f952e3bcb1151291994742cd359b350c.svg#logo-small",
      toString: function () {
        return this.url;
      }
    }